export class CacheTranslation
{
    public Key: string;
    public Value: string;
 
    constructor(
        obj: CacheTranslation
    )
    {
        this.Key = obj.Key,
        this.Value = obj.Value;
    }
}